import React from "react";
import Container from "./../ui/container";
import { Link } from "react-router-dom";
import FooterAbout from "./footer-about";
import {
  COMPANY_SERVICE_LINKS,
  FOOTER_SERVICE_LINKS,
} from "./../constant/links";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa";
import "./../css/footer.css";
import footerimg from "../assets/images/footer-shape-left.webp";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-shape-left">
        <img src={footerimg} alt="" style={{ maxWidth: "100%" }} />
      </div>

      <div className="footer-main">
        <Container className="footer-container">
          <div className="footer-grid">
            <FooterAbout />
            <div className="footer-links-grid">
              <FooterLinkColumn title="Service" links={FOOTER_SERVICE_LINKS} />
              <FooterLinkColumn title="Company" links={COMPANY_SERVICE_LINKS} />
              {/* <div className="grid h-max gap-5">
                <FooterTitle>Newsletter</FooterTitle>
                <p className="text-lg text-gray-20">
                  Feel free to reach out if you want to collaborate or simply
                  chat.
                </p>
                <form className="bg-white flex p-4 gap-2 items-center w-full">
                  <FaEnvelope className="text-[24px] leading-[1] opacity-80" />
                  <input
                    type="text"
                    typeof="email"
                    required
                    className="flex-1 outline-0 w-full text-lg placeholder:text-gray-50"
                    placeholder="Email Address"
                  />
                  <button className="cursor-pointer" type="submit">
                    <FaPaperPlane className="text-[24px] leading-[1]" />
                  </button>
                </form>
              </div> */}
              <div className="footer-social">
                <FooterTitle>Social Media</FooterTitle>
                <div className="footer-social-icons">
                  <Link className="footer-social-link" to="/">
                    <FaFacebookF />
                  </Link>
                  <Link className="footer-social-link" to="/">
                    <FaTwitter />
                  </Link>
                  <Link className="footer-social-link" to="/">
                    <FaInstagram />
                  </Link>
                  <Link className="footer-social-link" to="/">
                    <FaLinkedinIn />
                  </Link>
                </div>
              </div>
              <div className="footer-west-coast">
                <FooterTitle>West Coast</FooterTitle>
                <ul className="footer-link-list">
                  <FooterLinkItem href="">
                    {/* 17011 Beach Blvd. Suite 900 Huntington Beach, CA 92647 */}
                    11542 Knott Street, Unit B7, Garden Grove, CA 92841
                  </FooterLinkItem>
                </ul>
                <FooterTitle>Service Area</FooterTitle>
                <ul className="footer-service-area footer-link-list">
                  <FooterLinkItem href="">
                    Serving the states of California, Washington, Oregon,
                    Nevada, Arizona & Houston, Texas
                  </FooterLinkItem>
                  <FooterLinkItem href="tel:2133289074">
                    (213) 328-9074
                  </FooterLinkItem>
                  <FooterLinkItem href="mailto:johnny@psenvironmental.com">
                    johnny@psenvironmental.com
                  </FooterLinkItem>
                  <FooterLinkItem href="mailto:services@psenvironmental.com">
                    services@psenvironmental.com
                  </FooterLinkItem>
                  <FooterLinkItem href="mailto:info@psenvironmental.com">
                    {/*//joe@psenvironmental.com*/}
                    info@psenvironmental.com
                  </FooterLinkItem>
                  <FooterLinkItem href="">
                    CA Contractor License 814629
                  </FooterLinkItem>
                  <FooterLinkItem href="">
                    License / Bonded / Insured
                  </FooterLinkItem>
                </ul>
              </div>
              {/* <div className="grid h-max gap-5">
                <FooterTitle>East Coast</FooterTitle>
                <ul>
                  <FooterLinkItem href="">
                    878 Donegal Drive Follansbee, WV. 26037
                  </FooterLinkItem>
                </ul>
                <FooterTitle>Service Area</FooterTitle>

                <ul className="grid gap-3">
                  <FooterLinkItem href="">
                    Serving the states of “coming soon”
                  </FooterLinkItem>
                  <FooterLinkItem href="tel:13043741775">
                    (304) 374-1775
                  </FooterLinkItem>
                  <FooterLinkItem href="mailto:joe@psenvironmental.com">
                    joe@psenvironmental.com
                  </FooterLinkItem>
                </ul>
              </div> */}
            </div>
          </div>
        </Container>
      </div>
      <div className="footer-bottom">
        <Container>
          <div className="footer-bottom-content">
            <span className="footer-copyright">
              &copy; {new Date().getFullYear()} PS Enviromental Services INC.
            </span>
            {/* <Link
              href="/"
              className="text-white transition-all duration-300 ease-in-out hover:text-blue-70 max-sm:order-1"
            >
              Privacy & Cookie Policy
            </Link> */}
          </div>
        </Container>
      </div>
    </footer>
  );
};

// FooterLinkColumn component
const FooterLinkColumn = ({ title, links }) => {
  return (
    <div className="footer-link-column">
      <FooterTitle>{title}</FooterTitle>
      <ul className="footer-link-list">
        {links.map((item) => (
          <FooterLinkItem href={item.href} key={item.name}>
            {item.name}
          </FooterLinkItem>
        ))}
      </ul>
    </div>
  );
};

// FooterTitle component
const FooterTitle = ({ children }) => {
  return <span className="footer-title">{children}</span>;
};

// FooterLinkItem component
const FooterLinkItem = ({ children, href }) => {
  return (
    <li>
      <Link to={href} className="footer-link-item">
        {children}
      </Link>
    </li>
  );
};

export default Footer;
